var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.label))]),(_vm.status)?_c('b-badge',{staticClass:"badge-outlined",attrs:{"pill":"","variant":_vm.badge}},[_vm._v(_vm._s(_vm.$t(_vm.status)))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }